import { Component, createRef } from 'react';
import { Form, Button, Spinner, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  setAuthentication,
  setFirebaseToken,
} from '../../redux/slices/authSlice';
import {
  setLanguages,
  setDefaultLanguage,
  setLangLabels,
  refreshLangLabels,
} from '../../redux/slices/langSlice';
import { setDefaultTheme } from '../../redux/slices/themeSlice';
import { setClassAndSubject } from '../../redux/slices/selectedClassSlice';
import { toast } from 'react-toastify';
import logo from '../../assets/images/educore-new.png';
import loginImg from '../../assets/images/login-img.png';
import signingGoogle from '../../assets/images/signin-google.png';
import signingMicrosoft from '../../assets/images/signin-microsoft.png';
import axios from 'axios';
import { t } from '../../helpers/translation_helper';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { firebaseApp } from '../../services/firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { themes } from '../../constants/themes';
import Slider from "react-slick";
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginWrapper from '../../wrappers/GoogleLoginWrapper';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ReCAPTCHA from "react-google-recaptcha";
import sessionService from '../../services/session';
import { GET } from '../../api';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';

const apiURL = process.env.REACT_APP_API_URL;
const dxbStorageURL = process.env.REACT_APP_STORAGE_URL_DXB;

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: "b0b93e96-a815-4fd8-8724-38855f333745",
    authority: "https://login.microsoftonline.com/common",
    // redirectUri: "http://locahost:3000",
    redirectUri: window.location.origin,
  },
});

/**
 * Login Component
 */
class Login extends Component {

  googleLoginRef = createRef();

  /**
   * @constructor
   * @param {any} props
   */
  constructor(props) {
    super(props);

    this.state = {
      working: false,
      username: '',//grace
      password: '',//Ol@l@
      langLabels: [],
      langOffset: 0,
      loader: false,
      showPass: false,
      redirectToDashboard: false,
      authData: null,
      showBannerModal: false,
      recaptchaToken: "",
      banner: null,
    };
  }

  /**
   * Component Did Mount
   */
  componentDidMount() {
    this.props.refreshLangLabels(this.state.langOffset)

    axios.get(apiURL + 'language/get-languages').then((res) => {
      if (res.data.type) {
        this.props.setLanguages(res.data.data);
        const defaultLanguage = res.data.data.find((item) => {
          return item.lang_name == 'English';
        });
        this.props.setDefaultLanguage(defaultLanguage);
      } else {
        toast.error(t('Something went wrong!'));
      }
    });

    this.getLoginBanner();
  }

  /**
   * Handle Field
   * @param {event} e Event
   * @param {string} field Field name
   */
  handleField = (e, field) => {
    this.setState({ [field]: e.target.value });
  };

  authenticateUserAndGetTenantID = async (username, password) => {
    try {
      const res = await axios.get(apiURL + 'auth-user', {
        withCredentials: true,
        auth: {
          username: username,
          password: password,
        },
        params: {
          appname: process.env.REACT_APP_NAME,
        }
      });

      if (res.data.type) {
        return {
          success: true,
          tenant_id: res.data.tenantID
        };
      } else {
        return {
          success: false,
          message: res.data.message
        };
      }
    } catch (err) {
      console.log('Authentication error:', err);
      return {
        success: false,
        message: err.response?.data?.message || 'Authentication failed'
      };
    }
  };

  /**
   * Handle Login
   * @param {event} e Event
   */
  handleLogin = async (e) => {
    e.preventDefault();
    const { username, password, recaptchaToken } = this.state;

    if (!recaptchaToken) {
      toast.error("Please complete the reCAPTCHA.");
      return;
    }

    this.setState({ working: true });

    if (username == '' || password == '') {
      this.setState({ working: false });
      toast.error('Username and password is required.');
      return;
    }

    try {
      const authResult = await this.authenticateUserAndGetTenantID(username, password);

      if (!authResult.success) {
        this.setState({ working: false });
        toast.error(authResult.message);
        return;
      }

      const loginParams = {
        appname: process.env.REACT_APP_NAME,
      };

      if (authResult.tenant_id) {
        loginParams.tenant_id = authResult.tenant_id;
      }

      const res = await axios.get(apiURL + 'login', {
        withCredentials: true,
        auth: {
          username: username,
          password: password,
        },
        params: loginParams
      });

      if (res.data.type) {
        this.setState({ working: false });
        const { setAuthentication, setClassAndSubject, setFirebaseToken } = this.props;

        // Firebase token registration
        let isBrowserSupported = await isSupported()
        if (isBrowserSupported) {
          const messaging = getMessaging(firebaseApp);
          getToken(messaging, {
            vapidKey: 'BJ3u-j-0W2m1it06nryDvW8dV9X7uzl6i9la_lyEKPLYkmZHVxqGpCwF8l-vXCHx6sAcOa3O2WGnVdAsVbA2-Rc',
          })
            .then((currentToken) => {
              if (currentToken) {
                setFirebaseToken(currentToken);
                this.registerFirebase(currentToken, res.data.data.centerData.center_id, res.data.data.centerData.center_timezone, res.data.data.loginData.user_id, res.data.data.loginData.role_id, res.data.data.loginData.auth_key, res.data.data.centerData.tenant_id);
              } else {
                console.log('No registration token available. Request permission to generate one.');
              }
            })
            .catch((err) => {
              console.log('An error occurred while retrieving token. ', err);
            });
        }

        const role = res.data.data.loginData.role_id.toString();

        if (res.data.data.stdbanners || (res.data.data.educorebanner && JSON.parse(res.data.data.educorebanner.roles).includes(role))) {
          this.setState({
            authData: res.data.data,
            showBannerModal: true
          });
        } else {
          setAuthentication(res.data.data);
          sessionService.startSessionMonitoring();
        }

        if (res.data.data.classes[0].academic_classmain_subject.length > 0) {
          setClassAndSubject({ class: res.data.data.classes[0], subject: res.data.data.classes[0].academic_classmain_subject[0] });
        } else {
          setClassAndSubject({ class: res.data.data.classes[0], subject: null });
        }

      } else {
        this.setState({ working: false });
        toast.error(res.data.message);
      }
    } catch (err) {
      console.log('Login error:', err)
      this.setState({ working: false });
      if (err.response) {
        let resData = err.response.data
        if (resData) {
          toast.error(resData.message);
        } else {
          toast.error('Something went wrong!');
        }
      } else {
        toast.error('Something went wrong!');
      }
    }
  };

  /**
   * Register Firebase
   * @param {String} currentToken
   * @param {Number} center_id
   * @param {Number} center_timezone
   * @param {Number} user_id
   * @param {Number} role_id
   * @param {String} auth_key
   */
  registerFirebase = async (
    currentToken,
    center_id,
    center_timezone,
    user_id,
    role_id,
    auth_key,
    tenant_id
  ) => {
    let fData = new FormData();
    fData.append('currentToken', currentToken);
    fData.append('center_id', center_id);
    fData.append('center_timezone', center_timezone);
    fData.append('user_id', user_id);
    fData.append('role_id', role_id);
    try {
      const res = await axios.post(
        apiURL + 'authentication/register-firebase',
        fData,
        {
          params: {
            auth_key: auth_key,
            tenant_id: tenant_id,
            center_id: center_id,
            center_timezone: center_timezone,
            user_id: user_id,
            role_id: role_id,
            appname: process.env.REACT_APP_NAME,
          },
        }
      );
      // 
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while saving token!'));
    }
  };

  /*******************************/
  /*           GOOGLE            */
  /*******************************/
  handleGoogleSuccess = async (credentialResponse) => {
    try {
      const fData = new FormData();
      fData.append('access_token', credentialResponse.access_token);
      const res = await axios.post(
        apiURL + 'auth-user',
        fData,
        {
          params: {
            appname: process.env.REACT_APP_NAME,
            provider: 'google'
          },
        }
      );

      if (res.data.type) {
        const authUserData = res.data;

        const loginParams = {
          appname: process.env.REACT_APP_NAME,
        };

        if (authUserData.tenantID) {
          loginParams.tenant_id = authUserData.tenantID;
        }

        const loginRes = await axios.get(apiURL + 'login', {
          withCredentials: true,
          auth: {
            username: authUserData.user_name,
            password: authUserData.password,
          },
          params: loginParams
        });

        if (loginRes.data.type) {
          const { setAuthentication, setClassAndSubject, setFirebaseToken } = this.props;

          // Firebase token registration
          let isBrowserSupported = await isSupported()
          if (isBrowserSupported) {
            const messaging = getMessaging(firebaseApp);
            getToken(messaging, {
              vapidKey: 'BJ3u-j-0W2m1it06nryDvW8dV9X7uzl6i9la_lyEKPLYkmZHVxqGpCwF8l-vXCHx6sAcOa3O2WGnVdAsVbA2-Rc',
            })
              .then((currentToken) => {
                if (currentToken) {
                  setFirebaseToken(currentToken);
                  this.registerFirebase(
                    currentToken,
                    loginRes.data.data.centerData.center_id,
                    loginRes.data.data.centerData.center_timezone,
                    loginRes.data.data.loginData.user_id,
                    loginRes.data.data.loginData.role_id,
                    loginRes.data.data.loginData.auth_key,
                    loginRes.data.data.centerData.tenant_id,
                  );
                } else {
                  console.log('No registration token available. Request permission to generate one.');
                }
              })
              .catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
              });
          }

          const role = loginRes.data.data.loginData.role_id.toString();

          if (loginRes.data.data.stdbanners || (loginRes.data.data.educorebanner && JSON.parse(loginRes.data.data.educorebanner.roles).includes(role))) {
            this.setState({
              authData: loginRes.data.data,
              showBannerModal: true
            });
          } else {
            setAuthentication(loginRes.data.data);
            sessionService.startSessionMonitoring();
          }

          if (loginRes.data.data.classes[0].academic_classmain_subject.length > 0) {
            setClassAndSubject({ class: loginRes.data.data.classes[0], subject: loginRes.data.data.classes[0].academic_classmain_subject[0] });
          } else {
            setClassAndSubject({ class: loginRes.data.data.classes[0], subject: null });
          }

        } else {
          toast.error(loginRes.data.message);
        }

      } else {
        toast.error(res.data.message);
        return;
      }

    } catch (err) {
      console.log('Google login error:', err);
      if (err.response) {
        let resData = err.response.data
        if (resData) {
          toast.error(resData.message);
        } else {
          toast.error('Something went wrong!');
        }
      } else {
        toast.error(t('No linked Google account found!'));
      }
      return;
    }
  };

  handleGoogleError = () => {
    toast.error('Google Sign-In failed!');
  };

  handleGoogleLogin = () => {
    if (this.googleLoginRef.current) {
      this.googleLoginRef.current.triggerLogin();
    }
  };

  /*******************************/
  /*          MICROSOFT          */
  /*******************************/
  handleMicrosoftLogin = async () => {
    try {
      const response = await msalInstance.loginPopup({
        scopes: ["user.read"],
        prompt: "select_account",
      });

      const access_token = response.accessToken;

      const fData = new FormData();
      fData.append('access_token', access_token);

      const res = await axios.post(
        apiURL + 'auth-user',
        fData,
        {
          params: {
            appname: process.env.REACT_APP_NAME,
            provider: 'microsoft'
          },
        }
      );

      if (res.data.type) {
        const authUserData = res.data;

        const loginParams = {
          appname: process.env.REACT_APP_NAME,
        };

        console.log('authUserData', authUserData);

        if (authUserData.tenantID) {
          loginParams.tenant_id = authUserData.tenantID;
        }

        const loginRes = await axios.get(apiURL + 'login', {
          withCredentials: true,
          auth: {
            username: authUserData.user_name,
            password: authUserData.password,
          },
          params: loginParams
        });

        if (loginRes.data.type) {
          const { setAuthentication, setClassAndSubject, setFirebaseToken } = this.props;

          // Firebase token registration
          let isBrowserSupported = await isSupported()
          if (isBrowserSupported) {
            const messaging = getMessaging(firebaseApp);
            getToken(messaging, {
              vapidKey: 'BJ3u-j-0W2m1it06nryDvW8dV9X7uzl6i9la_lyEKPLYkmZHVxqGpCwF8l-vXCHx6sAcOa3O2WGnVdAsVbA2-Rc',
            })
              .then((currentToken) => {
                if (currentToken) {
                  setFirebaseToken(currentToken);
                  this.registerFirebase(
                    currentToken,
                    loginRes.data.data.centerData.center_id,
                    loginRes.data.data.centerData.center_timezone,
                    loginRes.data.data.loginData.user_id,
                    loginRes.data.data.loginData.role_id,
                    loginRes.data.data.loginData.auth_key,
                    loginRes.data.data.centerData.tenant_id,
                  );
                } else {
                  console.log('No registration token available. Request permission to generate one.');
                }
              })
              .catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
              });
          }

          const role = loginRes.data.data.loginData.role_id.toString();

          if (loginRes.data.data.stdbanners || (loginRes.data.data.educorebanner && JSON.parse(loginRes.data.data.educorebanner.roles).includes(role))) {
            this.setState({
              authData: loginRes.data.data,
              showBannerModal: true
            });
          } else {
            setAuthentication(loginRes.data.data);
            sessionService.startSessionMonitoring();
          }

          if (loginRes.data.data.classes[0].academic_classmain_subject.length > 0) {
            setClassAndSubject({ class: loginRes.data.data.classes[0], subject: loginRes.data.data.classes[0].academic_classmain_subject[0] });
          } else {
            setClassAndSubject({ class: loginRes.data.data.classes[0], subject: null });
          }

        } else {
          toast.error(loginRes.data.message);
        }

      } else {
        toast.error(res.data.message);
      }

    } catch (error) {
      console.error("Microsoft login error:", error);
      if (error.errorCode === "user_cancelled") {
        // User cancelled the login, don't show error
        return;
      }
      toast.error("Microsoft Sign-In failed!");
    }
  };


  handleRecaptchaChange = (token) => {
    this.setState({ recaptchaToken: token });
  };

  getLoginBanner = async () => {
    try {
      const res = await axios.get(apiURL + 'language/get-login-banner');
      console.log('res', res);
      if (res.status == 200) {
        this.setState({ banner: res.data.data });
      } else {
        console.log('Error fetching login banner:', res.data.message);
      }
    } catch (err) {
      console.log('Error fetching login banner:', err);
    }
  }

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    const { working, username, password, loader } = this.state;

    let bannerRole = false;

    if (this.state.authData && this.state.authData.educorebanner) {
      let bannerRoles = JSON.parse(this.state.authData.educorebanner.roles);
      const role = this.state.authData.loginData.role_id.toString();
      bannerRole = bannerRoles.includes(role);
    }

    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3576,
      pauseOnHover: false
    };

    console.log('STATE', this.state);

    if (loader) {
      return (
        <div id='loader'>
          <img src={require('../../assets/images/iedu-loader.gif')} alt='iEducore' width='120' />
          {t('Please wait...')}
          <br />
          {t('Setting up Academic Portal')}
        </div>
      );
    } else {
      return (
        <div style={{
          backgroundColor: '#5CBDEB',
          height: '100vh',
          width: '100vw',
        }}>
          <div id='login-form' className='d-flex justify-content-center align-items-center'>
            <div className='d-flex justify-content-center align-items-center'
              style={{ width: '50%', height: 705, backgroundColor: '#FAFAFA' }}>
              <img
                src={
                  this.state.banner && this.state.banner.lb_image
                    ? `${dxbStorageURL}loginbanners/${this.state.banner.lb_image}`
                    : loginImg
                }
                alt='iEducore'
                width='100%'
              />
            </div>
            <div style={{ width: '50%', height: 705, padding: 32 }}>
              <div className='text-center'>
                <img src={logo} alt='iEducore' width='150' />
              </div>
              <h3 className='text-center mt-4 mb-0'>{t('Welcome Back!')}</h3>
              <div className='text-center mt-1 mb-4 text-muted'>
                <small>{t('Sign in to access your account')}</small>
              </div>
              <GoogleOAuthProvider clientId="442389961490-j3l0rdb6avjckk0art33s7ebbn4lprtm.apps.googleusercontent.com">
                <button
                  onClick={this.handleGoogleLogin}
                  style={{
                    marginBottom: 16,
                    borderRadius: 7,
                    border: '1px solid rgba(0, 0, 0, 0.12)',
                    backgroundColor: 'white',
                    padding: 10,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <img src={signingGoogle} alt='Google' width='20' height='20' className='me-2' />{t('Continue with Google')}
                </button>
                <GoogleLoginWrapper
                  ref={this.googleLoginRef}
                  onSuccess={this.handleGoogleSuccess}
                  onError={this.handleGoogleError}
                />
              </GoogleOAuthProvider>
              <MsalProvider instance={msalInstance}>
                <button
                  onClick={this.handleMicrosoftLogin}
                  style={{
                    borderRadius: 7,
                    border: '1px solid rgba(0, 0, 0, 0.12)',
                    backgroundColor: 'white',
                    padding: 10,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <img src={signingMicrosoft} alt='Microsoft' width='20' height='20' className='me-2' />{t('Continue with Microsoft')}
                </button>
              </MsalProvider>
              <div className='text-center mt-4 mb-4 text-muted or-divider'>
                <small>{t('or continue with username')}</small>
              </div>
              <Form onSubmit={this.handleLogin}>
                <Form.Group className='mb-2' controlId='formBasicEmail'>
                  <Form.Label>{t('Username')}</Form.Label>
                  <Form.Control
                    value={username}
                    type='text'
                    placeholder='User Name'
                    onChange={(e) =>
                      this.handleField(e, 'username')
                    }
                    autoComplete={'username'}
                  />
                </Form.Group>
                <Form.Group
                  style={{ position: 'relative' }}
                  className='mb-4'
                  controlId='formBasicPassword'>
                  <Form.Label>{t('Password')}</Form.Label>
                  <Form.Control
                    value={password}
                    type={this.state.showPass ? 'text' : 'password'}
                    placeholder='Password'
                    onChange={(e) =>
                      this.handleField(e, 'password')
                    }
                    autoComplete={'password'}
                  />
                  <div style={{ position: 'absolute', bottom: 6, right: 10 }}>
                    <FontAwesomeIcon
                      icon={(this.state.showPass) ? faEyeSlash : faEye}
                      color={brand_colors[this.props.defaultTheme.theme_id].color18}
                      style={{ fontSize: 16, cursor: 'pointer' }}
                      onClick={() => this.setState({ showPass: !this.state.showPass })}
                    />
                  </div>

                </Form.Group>
                <button
                  style={{
                    width: '100%',
                    border: 'none',
                    color: 'white',
                    borderRadius: 7,
                    padding: 10,
                    fontWeight: 'bold',
                    backgroundColor: '#5CBDEB',
                    fontSize: 14
                  }}
                  type='submit'
                  disabled={working}>
                  {t('Login')}{' '}
                  {working ? (
                    <Spinner
                      as='span'
                      animation='grow'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    />
                  ) : (
                    ''
                  )}
                </button>
                <div className='d-flex justify-content-center' style={{ marginTop: 20 }}>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={this.handleRecaptchaChange}
                  />
                </div>
              </Form>
            </div>
          </div>
          {this.state.authData &&
            <Modal id="login-banner" size='xxl' centered show={this.state.showBannerModal}>
              <Modal.Body>
                <Slider {...settings}>
                  {this.state.authData.stdbanners &&
                    <div>
                      <div className='d-flex flex-column align-items-center'>
                        <img width="400" src={`${getRegionalStorageURL(this.state.authData.centerData.tenant_id) + this.state.authData.centerData.center_id}/stdbanners/${this.state.authData.stdbanners.picture}`} alt='Banner' /><br />
                        <strong>{this.state.authData.stdbanners.stdb_name}</strong>
                      </div>
                    </div>
                  }
                  {(this.state.authData.educorebanner && bannerRole) &&
                    <div>
                      <div className='d-flex flex-column align-items-center'>
                        <img width="400" src={`${dxbStorageURL}2/educorebanners/${this.state.authData.educorebanner.picture}`} alt='Banner' /><br />
                        <div dangerouslySetInnerHTML={{ __html: this.state.authData.educorebanner.banner_name }}></div>
                      </div>
                    </div>
                  }
                </Slider>
              </Modal.Body>
              <Modal.Footer>
                <button className='btn' style={{
                  backgroundColor: '#15bbe7',
                  color: 'white'
                }} onClick={() => {
                  this.props.setAuthentication(this.state.authData);
                  sessionService.startSessionMonitoring();
                }}>
                  {t('Proceed to Dashboard')}
                </button>
              </Modal.Footer>
            </Modal>
          }
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  defaultTheme: state.theme.defaultTheme,
  langLabels: state.language.langLabels,
  langRefreshing: state.language.langRefreshing,
});

const mapDispatchToProps = () => ({
  setAuthentication,
  setLanguages,
  setDefaultLanguage,
  setDefaultTheme,
  setLangLabels,
  setClassAndSubject,
  setFirebaseToken,
  refreshLangLabels,

});


export default connect(mapStateToProps, mapDispatchToProps())(Login);
